"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iCreateTRMVRMeter = exports.iTRMVRMeter = exports._iTRMVRMeter = exports.TRMVRMeterTypes = exports.iTRMVRMeterTypes = void 0;
const t = require("io-ts");
var iTRMVRMeterTypes;
(function (iTRMVRMeterTypes) {
    iTRMVRMeterTypes["TRMETER"] = "TRMETER";
    iTRMVRMeterTypes["MVRMETER"] = "MVRMETER";
})(iTRMVRMeterTypes = exports.iTRMVRMeterTypes || (exports.iTRMVRMeterTypes = {}));
// Enum-like validator
exports.TRMVRMeterTypes = t.keyof({
    [iTRMVRMeterTypes.TRMETER]: null,
    [iTRMVRMeterTypes.MVRMETER]: null,
});
exports._iTRMVRMeter = t.intersection([
    t.interface({
        id: t.number,
        trmvrmeter_uuid: t.string,
        project_uuid: t.string,
        usergroup_id: t.number,
        name: t.string,
    }),
    t.partial({
        perm: t.number,
        site_number: t.union([t.null, t.string]),
        meterType: exports.TRMVRMeterTypes,
        created_at: t.number,
        updated_at: t.number,
        folder_id: t.number,
        folder_uuid: t.string
    })
]);
const _iCreateTRMVRMeter = t.interface({
    usergroup_id: t.number,
    name: t.string,
    site_number: t.string,
    meter_type: exports.TRMVRMeterTypes,
    project_uuid: t.string,
    folder_id: t.number,
    folder_uuid: t.string
});
exports.iTRMVRMeter = t.clean(exports._iTRMVRMeter);
exports.iCreateTRMVRMeter = t.clean(_iCreateTRMVRMeter);
//# sourceMappingURL=trmvrmeter.js.map